<div
  class="group bg-card border border-border-inverted dropshadow-sm w-[380px] max-w-full h-fit min-h-[116px] flex flex-col justify-center pt-[16px] pb-[16px] items-start rounded-lg relative overflow-hidden"
>
  <div
    (click)="close.emit(alertItem)"
    class="w-[40px] h-[40px] flex justify-center items-center cursor-pointer opacity-50 transition-opacity duration-200 hover:opacity-100 absolute top-[0] right-[0] z-10"
  >
    <i
      class="fi fi-rr-cross-small text-muted-foreground leading-[13px] text-[16px]"
    ></i>
  </div>
  <div class="pr-[16px] pl-[16px] flex items-center">
    <div class="flex items-center mr-[16px]">
      <div
        [ngClass]="{
          'bg-success-fade': alertItem.type === 'success',
          'bg-danger-fade': alertItem.type === 'danger',
          'bg-warning-fade': alertItem.type === 'warning',
          'bg-blue-fade': alertItem.type === 'info'
        }"
        class="w-[32px] h-[32px] rounded-full flex items-center justify-center"
      >
        @switch (alertItem.type) { @case ('success') {
        <img
          src="assets/images/check.png"
          alt="Success Icon"
          class="w-[16px] h-[16px]"
        />
        } @case ('warning') {
        <img
          src="assets/images/octagon-exclamation.png"
          alt="Warning Icon"
          class="w-[16px] h-[16px]"
        />
        } @case ('danger') {
        <img
          src="assets/images/cross.png"
          alt="Danger Icon"
          class="w-[16px] h-[16px]"
        />
        } 
         @case ('info') {
         <div class="text-blue flex items-center justify-center">
           <i class="fi fi-rr-information h-full items-center leading-[0] text-[13px] text-center"></i>
         </div>
        }
      }
      </div>
    </div>
    <div class="flex flex-col items-start">
      <h2 class="text-foreground content-semibold leading-[24px]">
        {{ alertItem.title | translate }}
      </h2>
      <p
        class="content-sm-regular text-muted-foreground leading-[20px] pb-[8px]"
      >
        {{ alertItem.message | translate }}
      </p>
      @if (alertItem.textPrimaryButton) {
      <lib-button [type]="'outline'" (click)="actionButton()">
        {{ alertItem.textPrimaryButton | translate }}
      </lib-button>
      }
    </div>
  </div>
  <div
    [ngClass]="{
      'bg-success-fade': alertItem.type === 'success',
      'bg-danger-fade': alertItem.type === 'danger',
      'bg-warning-fade': alertItem.type === 'warning',
      'bg-blue-fade': alertItem.type === 'info'
    }"
    class="w-full h-[4px] absolute bottom-0"
  >
    <div
      (animationend)="animationEnd()"
      [ngClass]="{
        'bg-success': alertItem.type === 'success',
        'bg-danger': alertItem.type === 'danger',
        'bg-warning translate-x-[0]': alertItem.type === 'warning',
        'bg-blue': alertItem.type === 'info',
        'animate-duration-[10s]': alertItem.textPrimaryButton
      }"
      class="h-full animate-toast-progress group-hover:animate-pause"
    ></div>
  </div>
</div>
